<template>
  <div
    :id="item.id"
    class="pa-6 stop-card"
    :class="{'mb-4': !last }">
    <div class="flex flex-between">
      <router-link
        class="pb-3 h3-headline text-left"
        :to="titleHref">
        {{ item.usreou }} {{ item.organizationName ? ' - ' + item.organizationName : '' }}
      </router-link>
      <div
        class="flex flex-right ml-5">
        <StatusChip
          class="my-auto"
          key-name="status_key"
          name="status_name"
          :status="item"
          style="max-width: 245px;"/>
        <sPopover
          class="my-auto"
          placement="left-end"
          popper-class="stop-card-options-menu"
          trigger="click"
          width="240">
          <sButton
            slot="reference"
            icon="menu"
            small
            type="text"/>
          <div
            class="purch-card-menu menu pa-0">
            <MenuItem
              :disabled="changeStatus || $acl.get.includes('tenders_view')"
              :icon="item.status == 'C' ? 'repeat' : 'accept'"
              :label="item.status == 'C' ? $t('StopLists.LockAgain') : $t('StopLists.UnockAheadOfTime')"
              @click="item.status == 'C' ? blockAgain() : unlock()"/>
          </div>
        </sPopover>
      </div>
    </div>
    <div>
      <div class="pt-1">
        <div
          class="flex flex-wrap mt-2">
          <KeyValue
            :caption="$t('StopLists.LockDate')"
            :class="colClass">
            {{ formDate(item.dateFrom) }}
          </KeyValue>
          <KeyValue
            :caption="$t('StopLists.BlockingPeriod')"
            :class="colClass">
            {{ date_to(item) }}
          </KeyValue>
          <KeyValue
            v-if="showOrganisation"
            :caption="$t('StopLists.BlockedFor')"
            :class="colClass"
            :value="item.blocked_for"/>
          <KeyValue
            :caption="$t('StopLists.WhoBlocked')"
            :class="colClass">
            <div class="h7-text">
              {{ item.addUser }}
            </div>
            <div
              class="h8-text secondary__green_not_active--text mb-2 ">
              {{ item.addUserOrganization }}
            </div>
          </KeyValue>
          <KeyValue
            v-if="item.editUser || item.unlockedAuthomatically"
            :caption="$t('StopLists.WhoUnlocked')"
            :class="colClass">
            <div class="h7-text">
              {{ item.editUser ? item.editUser : item.unlockedAuthomatically ? $t('StopLists.Authomatically') : '' }}
            </div>
            <div
              class="h8-text secondary__green_not_active--text mb-2 ">
              {{ item.editUserOrganization }}
            </div>
          </KeyValue>
        </div>
        <KeyValue
          v-if="item.lockReason"
          :caption="$t('StopLists.BlockingReason')"
          class="mt-3"
          :value="item.lockReason"/>
      </div>
    </div>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import KeyValue from 'components/common/KeyValue.vue'

/* eslint-disable vue/no-mutating-props */
import StatusChip from 'components/common/elements/StatusChip.vue'
import { stopListsMixin } from 'mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'stopCard',
  mixins: [stopListsMixin],
  data() {
    return {
      changeStatus: false,
    }
  },
  props: {
    item: Object,
    last: Boolean,
    'show-organisation': Boolean
  },
  computed: {
    ...mapGetters({
      user: 'GET_USER',
    }),
    colClass() {
      let result = 'width-30'
      const fullTable = this.showOrganisation && (this.item.editUser || this.item.unlockedAuthomatically)
      if (fullTable) {
        result = 'width-20'
      } else if (this.showOrganisation || this.item.editUser || this.item.unlockedAuthomatically) {
        result = 'width-25'
      }
      return result
    },
    titleHref() {
      if (this.item.organizationId) {
        return {name: 'orgBlockingHistory', params: {usreou: this.item.usreou.trim() }, query: { id: this.item.organizationId }}
      } else {
        return {name: 'orgBlockingHistory', params: {usreou: this.item.usreou.trim() }}
      }
    },
  },
  methods: {
    blockAgain() {
      this.$router.push({name: 'addToStopList', params: {org: this.$route.params.org}, query: {usreou: this.item.usreou?.trim(), id: this.item.organizationId } })
    },
    unlock() {
      this.changeStatus = true
      this.$store.dispatch('unlockInStopListByOrganizer', { usreou: this.item.usreou, organizationId: this.item.organizationId, unLockReason: '' })
        .then(res => {
          if ( res ) {
            this.item.status = 'C'
            this.item.editUser = this.user.profile?.family_name || '' + ' ' + this.user.profile?.name || ''
            this.setStatus(this.item)

            this.$store.dispatch('getStopList', true)

            this.changeStatus = false
          }
        })
    },
  },
  components: {
    MenuItem,
    KeyValue,
    StatusChip
  }
}
</script>
<style lang="scss">
.stop-card {
   border-radius: 8px !important;
   background-color: var(--v-main__light_green-base) !important;
  border-color: var(--v-main__light_green-base) !important;
  .v-list-item__content {
    align-self: flex-start;
  }
}
</style>
